var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Drawer, Grid, Skeleton, Step, StepContent, StepLabel, Stepper, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { serviceHistoryUrl } from '../../../api/url';
import { CrossIcon } from '../../../assets/images';
import CustomerAndVehicleInfo from '../../../modules/commonViews/searchByType/customerAndVehicleInfo';
import { showLoader } from '../../../redux/commonSlice';
import { getByIdAPI } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import { dateFormate } from '../../../utils/utils';
import { MuiBox } from '../../atoms/boxComponent';
import { MuiIconButton } from '../../atoms/iconButtonComponent';
import { MuiStack } from '../../atoms/stackComponent';
import NoDocumentFoundPage from '../noDocumentsFoundPage';
import ServiceDetailsModal from './serviceDetailsModal';
var DrawerHeader = styled('div')(function (_ref) {
    var theme = _ref.theme;
    return _objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar);
});
export default function ServiceHistory(props) {
    var _this = this;
    var _commonState$isLoader;
    var installBaseId = props.installBaseId, vehicleSelected = props.vehicleSelected, customerDetails = props.customerDetails, isServiceHistoryLabel = props.isServiceHistoryLabel, isDisabled = props.isDisabled;
    var _a = useState(false), viewServiceHistory = _a[0], setViewServiceHistory = _a[1];
    var _b = useState({}), selectedServices = _b[0], setSelectedServices = _b[1];
    var _c = useState([]), serviceHistoryList = _c[0], setServiceHistoryList = _c[1];
    var dispatch = useDispatch();
    var commonState = useAppSelector(function (state) { return state.common; });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    useEffect(function () {
        serviceHistoryApiCall();
    }, []);
    var serviceHistoryApiCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload, _response$payload2, payload, response, _response$payload3, _response$payload4, _response$payload5, _response$payload6, _response$payload7, _response$payload8, updatedServiceHistory, JCLabour, JCSpare, WithTotal, _loop_1, _i, updatedServiceHistory_1, updatedServiceItem, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    payload = {
                        "InstallBaseId": installBaseId
                        //"InstallBaseId": '753d808d-070c-4b64-bdca-c67afb64072e'
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "ServiceHistoryDetails",
                            url: serviceHistoryUrl,
                            request: payload
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        updatedServiceHistory = response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && (_response$payload3 = _response$payload3.value) !== null && _response$payload3 !== void 0 && (_response$payload3 = _response$payload3.data) !== null && _response$payload3 !== void 0 && _response$payload3.ServiceDetails ? __spreadArray([], (response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.value) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.ServiceDetails), true) : [];
                        JCLabour = response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.value) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.data) !== null && _response$payload5 !== void 0 && _response$payload5.JCLabour ? response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.data) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.JCLabour : [];
                        JCSpare = response !== null && response !== void 0 && (_response$payload7 = response.payload) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.value) !== null && _response$payload7 !== void 0 && (_response$payload7 = _response$payload7.data) !== null && _response$payload7 !== void 0 && _response$payload7.JCLabour ? response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 || (_response$payload8 = _response$payload8.value) === null || _response$payload8 === void 0 || (_response$payload8 = _response$payload8.data) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.JCSpare : [];
                        WithTotal = [];
                        _loop_1 = function (updatedServiceItem) {
                            var JCLabourList = JCLabour.filter(function (item) { return String(item.ParentDocID) === String(updatedServiceItem.DocID); });
                            var JCSpareList = JCSpare.filter(function (item) { return String(item.ParentDocID) === String(updatedServiceItem.DocID); });
                            var LabourTotal = JCLabourList.reduce(function (total, el) { return (el.PaidAmount ? Number(el.PaidAmount) : 0) + Number(total); }, 0);
                            var PartTotal = JCSpareList.reduce(function (total, el) { return (el.PaidAmount ? Number(el.PaidAmount) : 0) + Number(total); }, 0);
                            WithTotal.push(_objectSpread(_objectSpread({}, updatedServiceItem), {}, {
                                TotalAmount: LabourTotal + PartTotal
                            }));
                        };
                        for (_i = 0, updatedServiceHistory_1 = updatedServiceHistory; _i < updatedServiceHistory_1.length; _i++) {
                            updatedServiceItem = updatedServiceHistory_1[_i];
                            _loop_1(updatedServiceItem);
                        }
                        setServiceHistoryList(WithTotal);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("Error-", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onViewServiceHistoryClick = function (item) {
        setSelectedServices(item);
        setViewServiceHistory(true);
    };
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "service-history-drawer",
        anchor: "right",
        open: props.isOpen,
        onClose: function () { return props.onClose(); },
        sx: {
            display: {
                xs: 'block'
            },
            '& .MuiDrawer-paper': {
                width: IS_MOBILE ? '100%' : 450
            }
        }
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            alignItems: 'center',
            backgroundColor: systemColor.white,
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 5,
        padding: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Typography, {
        style: {
            fontSize: '16px',
            fontWeight: '600'
        },
        color: "black"
    }, t('Service history'))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: function () { return props.onClose(); },
        style: {
            justifyContent: 'flex-end'
        },
        id: "cancelButton"
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIconBtn",
        src: CrossIcon
    }))))), /*#__PURE__*/ React.createElement(MuiStack, {
        px: 1.5,
        direction: 'column',
        alignItems: "center"
    }, vehicleSelected && customerDetails && /*#__PURE__*/ React.createElement(CustomerAndVehicleInfo, {
        VehiclesDetailsList: [vehicleSelected],
        customerDetails: customerDetails,
        isCheckBoxVisible: false,
        isServiceHistoryLabel: true,
        isDisabled: isDisabled,
        isFromServiceHistory: true,
        isOpenInDrawer: true
    }), (serviceHistoryList === null || serviceHistoryList === void 0 ? void 0 : serviceHistoryList.length) > 0 ? /*#__PURE__*/ React.createElement(Stepper, {
        activeStep: serviceHistoryList === null || serviceHistoryList === void 0 ? void 0 : serviceHistoryList.length,
        orientation: "vertical",
        style: {
            color: '#3697FF'
        }
    }, serviceHistoryList === null || serviceHistoryList === void 0 ? void 0 : serviceHistoryList.map(function (item, index) { /*#__PURE__*/ return React.createElement(Step, {
        key: index,
        active: true,
        expanded: true
    }, /*#__PURE__*/ React.createElement(StepLabel, {
        StepIconProps: {
            sx: {
                '&.Mui-active': {
                    color: systemColor.primary // Active step
                },
                '&.Mui-completed': {
                    color: systemColor.primary // Completed step
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "PreviouServiceHistoryDate",
        variant: "h6",
        color: '#8593A3'
    }, item.DocDate ? dateFormate(item.DocDate) : '-')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(StepContent, null, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'flex-start',
        direction: 'column',
        width: IS_MOBILE ? 'calc(80vw)' : IS_TABLET ? 'calc(38vw)' : 'calc(21vw)',
        sx: {
            backgroundColor: '#F4F7FA',
            borderRadius: '8px',
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: 'PreviousServiceJobType',
        variant: "h3",
        color: '#1B1D21'
    }, item.JobType ? item.JobType : '-'), /*#__PURE__*/ React.createElement(Typography, {
        id: "PreviousServiceKM",
        variant: "h4",
        color: '#6A7682',
        style: {
            marginTop: 3
        }
    }, item.UsageReading ? "".concat(item.UsageReading, " KM") : "- KM"), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        paddingTop: 1,
        width: '100%',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#6A7682'
    }, "Paid Amount:"), /*#__PURE__*/ React.createElement(Typography, {
        id: "PreviousServiceAmount",
        variant: "h3",
        color: '#1B1D21'
    }, "\u20B9", item.TotalAmount ? Number(item.TotalAmount).toFixed(2) : 0, " ")), /*#__PURE__*/ React.createElement(Button, {
        id: "vehicleHistoryView",
        variant: "text",
        size: "small",
        sx: {
            m: 0,
            p: 0,
            minWidth: 0,
            backgroundColor: '#F4F7FA',
            color: bajajPrimaryBlue,
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'NotoSans-Medium'
        },
        onClick: function () { return onViewServiceHistoryClick(item); }
    }, t('View'))))))); })) : /*#__PURE__*/ React.createElement(React.Fragment, null, commonState !== null && commonState !== void 0 && (_commonState$isLoader = commonState.isLoader) !== null && _commonState$isLoader !== void 0 && _commonState$isLoader.isLoaderOpen ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        padding: 1,
        style: {
            width: '100vw',
            height: '60vh'
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rectangular",
        animation: "wave",
        width: "100%",
        height: '100%'
    })) : /*#__PURE__*/ React.createElement(NoDocumentFoundPage, {
        title: t("No service history available against selected vehicle"),
        paragraph: t("")
    }))), /*#__PURE__*/ React.createElement(ServiceDetailsModal, {
        isModalVisible: viewServiceHistory,
        selectedServiceData: selectedServices,
        onCloseModal: function () { return setViewServiceHistory(function (prev) { return !prev; }); }
    }));
}
